import moment from 'moment-timezone';
import { BaseComponentPropKeysArray } from '../components/elements/baseComponentProps.js';
import { AriaPropsArray } from '../components/elements/ariaAttributeProps.js';
import { pick } from 'lodash';
import { DatepickerInputEventsArray } from '../types/DatepickerAttributes.js';

const determineDataTestIdPrefix = (props, backup = '') => {
    if ('data-testid' in props)
        return props['data-testid'];
    return (props === null || props === void 0 ? void 0 : props.id) ? `${props === null || props === void 0 ? void 0 : props.id}` : backup;
};
const getBaseProps = (props) => {
    return pick(props, BaseComponentPropKeysArray);
};
const getAriaProps = (props) => {
    return pick(props, AriaPropsArray);
};
const getDatePickerEventProps = (props) => {
    return pick(props, DatepickerInputEventsArray);
};
const commitChangesToGrid = (props, formattedDate) => {
    var _a, _b, _c;
    (_a = props.isEditingToggle) === null || _a === void 0 ? void 0 : _a.call(props);
    const collateralID = props.data.collateral_item_id;
    const changeTracker = (props === null || props === void 0 ? void 0 : props.getChangeTracker) ? props.getChangeTracker() : {};
    const changeRecord = (_b = changeTracker[collateralID]) !== null && _b !== void 0 ? _b : {
        pristineDate: props.value,
    };
    const isoDate = formattedDate &&
        moment.tz(formattedDate, 'MM/DD/YYYY', true, moment.tz.guess(true)).utc().format(moment.defaultFormatUtc);
    const newChangeRecord = Object.assign(Object.assign({}, changeRecord), { [props.colDef.colId]: isoDate, collateral_item_id: collateralID, collateral_type_id: props.data.collateral_type_id, sales_status_id: props.data.sales_status_id });
    const newData = Object.assign(Object.assign({}, props.node.data), { [props.colDef.colId]: formattedDate });
    props.node.setData(newData);
    (_c = props.updateChangeTracker) === null || _c === void 0 ? void 0 : _c.call(props, props.data.collateral_item_id, newChangeRecord, props.node, props.colDef);
};

export { commitChangesToGrid, determineDataTestIdPrefix, getAriaProps, getBaseProps, getDatePickerEventProps };
//# sourceMappingURL=propHelpers.js.map
